<template>
    <div class="container section">
        <nav class="columns">
            <div class="column has-text-centered">
                <h2 class="title">Get in touch</h2>
                <div v-if="success" class="notification is-primary">
                    {{ success }}
                </div>
                <div v-if="error.message" class="notification is-danger">
                    {{ error.message }}
                </div>
                <div class="box">
                    <form>
                        <div class="field">
                            <div class="control">
                                <input class="input"
                                       v-bind:class="{ 'is-danger': error.errors.name }"
                                       v-model="contactForm.name"
                                       type="text"
                                       placeholder="Your name">
                                <p v-if="error.errors.name" class="help is-danger">{{ error.errors.name[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input"
                                       v-model="contactForm.company"
                                       v-bind:class="{ 'is-danger': error.errors.company }"
                                       type="text"
                                       placeholder="Your Company">
                                <p v-if="error.errors.company" class="help is-danger">{{ error.errors.company[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input"
                                       v-model="contactForm.email"
                                       v-bind:class="{ 'is-danger': error.errors.email }"
                                       type="email"
                                       placeholder="Your email">
                                <p v-if="error.errors.email" class="help is-danger">{{ error.errors.email[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input"
                                       v-bind:class="{ 'is-danger': error.errors.phone }"
                                       v-model="contactForm.phone"
                                       type="number"
                                       placeholder="Your phone">
                                <p v-if="error.errors.phone" class="help is-danger">{{ error.errors.phone[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <textarea class="textarea"
                                          v-bind:class="{ 'is-danger': error.errors.body }"
                                          v-model="contactForm.body"
                                          placeholder="e.g. Hello world">
                                </textarea>
                                <p v-if="error.errors.body" class="help is-danger">{{ error.errors.body[0] }}</p>
                            </div>
                        </div>
                        <button class="button is-block is-primary is-large is-fullwidth"
                                v-bind:class="{ 'is-loading': isLoading }"
                                @click.prevent="sendContactForm">Send message</button>
                    </form>
                </div>
            </div>
            <div class="column has-text-centered">
                <article class="media single-spaced border-less">
                    <div class="media-content">
                        <div class="content has-text-centered">
                            <h5 class="heading">Headquarters</h5>
                            <p>
                                <i class="fas fa-home"></i>  BIZ SMART KAYABACHO #319, SHINKAWA 1-3-21, CHUO-KU, TOKYO-TO, 104-0033
                            </p>
                            <p>
                                <i class="fas fa-phone"></i> +(81) 3-6822-4757
                            </p>
                            <p>
                                <i class="fas fa-at"></i>  b.o@unetworld.com
                            </p>
                        </div>
                    </div>
                </article>
                <article class="media single-spaced border-less">
                    <div class="media-content">
                        <div class="content has-text-centered">
                            <h5 class="heading">Paraguay</h5>
                            <p>
                                <i class="fas fa-home"></i>  Mcal. Estigarribia 2268 c/22 de Septiembre
                            </p>
                            <p>
                                <i class="fas fa-phone"></i> +595 0982 753 317
                            </p>
                            <p>
                                <i class="fas fa-at"></i>  paraguay@unetworld.com
                            </p>
                        </div>
                    </div>
                </article>
                <article class="media single-spaced border-less">
                    <div class="media-content">
                        <div class="content has-text-centered">
                            <h5 class="heading">Trinidad and Tobago</h5>
                            <p>
                                <i class="fas fa-home"></i>  LP#4 First Trace Maingot Road, Tunapuna
                            </p>
                            <p>
                                <i class="fas fa-phone"></i> +81 80 6785 9295
                            </p>
                            <p>
                                <i class="fas fa-at"></i>  brent@unetworld.com
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </nav>
    </div>
</template>

<script>
    import apiForms from '../../api/apiForms'
    export default {
        data () {
            return {
                contactForm : {
                    name: '',
                    email: '',
                    phone: '',
                    company: '',
                    body: ''
                },
                error: {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        company: '',
                        body: ''
                    }
                },
                success: '',
                isLoading: false
            }
        },
        methods: {
            sendContactForm () {
                this.isLoading = true
                this.clearErrors()
                apiForms
                    .homePageContactFormRequest(this.contactForm)
                    .then((response) => {
                        this.success = response.data.success
                        this.clearForm()
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.isLoading = false
                        if ( err.response && err.response.status === 422 ) {
                            this.error.errors = err.response.data
                        } else {
                            this.error.message = 'Connection error!'
                        }
                    })
            },
            clearForm () {
                this.contactForm = {
                    name: '',
                    email: '',
                    phone: '',
                    company: '',
                    body: ''
                }
            },
            clearErrors () {
                this.error = {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        company: '',
                        body: ''
                    }
                }
            }
        }

    }
</script>

<style scoped>
    article {
        border-top: none !important;
        padding-bottom: 5px !important;
    }
    .media-left {
        padding-left: 15px;
    }
    .media-left .icon {
        margin-top: 15px;

    }
    .media-content {
        padding-left: 25px;
    }

    .media {
        background-color: #ffffff;
        padding: 25px;
    }
    .single-spaced, .single-spaced * {
        line-height: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home/Offices.vue